import { Button } from '@consta/uikit/Button'
import { memo } from 'react'

type FooterProps = {
  canConfirm: boolean
  onSave: () => void
  onConfirm: () => Promise<void>
}

export const Footer = memo<FooterProps>(function Footer({ canConfirm, onConfirm }) {
  const handleClick = () => void onConfirm()

  return (
    <Button
      size="xs"
      view="primary"
      label="Рассчитать"
      disabled={!canConfirm}
      onClick={handleClick}
    />
  )
})
